import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getHeaders } from "../utils/helper";

export const moduleServerApi = createApi({
  reducerPath: "moduleServerApi",
  baseQuery: fetchBaseQuery({ baseUrl: process?.env?.REACT_APP_API_HOST_URL }),
  tagTypes: ["Module"],
  endpoints: (builder) => ({
    getUserModule: builder.query({
      query: () => ({
        url: "/user/modules",
        headers: getHeaders(),
      }),
      providesTags: ["Module"],
    }),
    updateModuleStatus: builder.mutation({
      query: ({ moduleNo, ...body }) => ({
        url: `/user/modules/${moduleNo}/status/update`,
        method: "PUT",
        headers: getHeaders(),
        body,
      }),
      invalidatesTags: ["Module"],
    }),
    completeTraining: builder.mutation({
      query: ({ moduleNo, ...body }) => ({
        url: `/user/modules/${moduleNo}/core_training_complete`,
        method: "POST",
        headers: getHeaders(),
        body: { ...body },
      }),
      invalidatesTags: ["Module"],
    }),
    downloadCertificate: builder.mutation({
      query: () => ({
        method: "GET",
        url: "/user/download/core_training_certificate",
        headers: getHeaders(),
      }),
      invalidatesTags: ["Module"],
    }),
    getTrainingMenuBasedOnModule: builder.query({
      query: (ModuleId) => ({
        url: `/user/modules/${ModuleId}/menus`,
        headers: getHeaders(),
      }),
      transformResponse: ({ data }) => data,
      providesTags: ["Module"],
    }),
    bookmarkModule: builder.mutation({
      query: ({ moduleNo, ...body }) => ({
        url: "/user/modules/request/slide/bookmark",
        method: "POST",
        headers: getHeaders(),
        body: { ...body },
      }),
      transformResponse: ({ data }) => data,
      invalidatesTags: ["Module"],
    }),
    resumeTraining: builder.mutation({
      query: (moduleNo) => ({
        method: "GET",
        url: `/user/modules/${moduleNo}/resume/slide`,
        headers: getHeaders(),
      }),
      invalidatesTags: ["Module"],
    }),
    fetchQuestionsAnswered: builder.mutation({
      query: (body) => ({
        url: "/user/modules/request/slide/fetch_question_answer",
        method: "POST",
        headers: getHeaders(),
        body,
      }),
      transformResponse: ({ data }) => data,
      invalidatesTags: ["Module"],
    }),
    saveAnswere: builder.mutation({
      query: (body) => ({
        url: "user/modules/request/slide/save_answer",
        method: "POST",
        headers: getHeaders(),
        body,
      }),
      transformResponse: ({ data }) => data,
      invalidatesTags: ["Module"],
    }),
    getAllQuestionAnswer: builder.query({
      query: (ModuleId) => ({
        url: `/user/modules/${ModuleId}/dashboard_question_answer`,
        headers: getHeaders(),
      }),
      transformResponse: ({ data }) => data,
      providesTags: ["Module"],
    }),

  }),
});

export const {
  useGetUserModuleQuery,
  useUpdateModuleStatusMutation,
  useCompleteTrainingMutation,
  useDownloadCertificateMutation,
  useGetTrainingMenuBasedOnModuleQuery,
  useBookmarkModuleMutation,
  useResumeTrainingMutation,
  useFetchQuestionsAnsweredMutation,
  useSaveAnswereMutation,
  useGetAllQuestionAnswerQuery
} = moduleServerApi;
